import { render } from "./Grants.vue?vue&type=template&id=4d1c0c46"
import script from "./Grants.vue?vue&type=script&lang=js"
export * from "./Grants.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__